import { CustomIcon } from 'components/templates/CustomIcon'

type TrayIconProps = {
  active?: boolean
  color?: string
  onClick?: () => void
}

export const TrayIcon = ({ active, color, onClick }: TrayIconProps) => (
  <CustomIcon
    active={active}
    color={color}
    addStatusColor={false}
    onClick={onClick}
    width="76.652"
    height="69.835"
    viewBox="0 0 76.652 69.835"
  >
    <path
      id="Path_17061"
      data-name="Path 17061"
      d="M0,176l2.643,19.4H74.009L76.652,176Z"
      transform="translate(0 -133.323)"
      fill="#6391f0"
    />
    <rect
      id="Rectangle_2768"
      data-name="Rectangle 2768"
      width="66.079"
      height="7.759"
      transform="translate(5.286 62.076)"
      fill="#5035ed"
    />
    <path
      id="Path_17062"
      data-name="Path 17062"
      d="M10.573,0,0,42.677H76.652L66.079,0Z"
      transform="translate(0)"
      fill="#98baff"
    />
    <path
      id="Path_17063"
      data-name="Path 17063"
      d="M32.7,79.038,39.309,48H86.886l6.608,31.038Z"
      transform="translate(-24.772 -36.361)"
      fill="#5035ed"
    />
  </CustomIcon>
)
